
export enum ManagedLinkKey {
	STORED_LINK = "stored-link",
	INFO_MEDICA = "informacion-medica",
	INFO_HOSPITALARIA = "informacion-hospitalaria",
	CLASIFICADOS = "clasificados",
	FOTOS = "fotos",
	CUMPLES = "cumples",
	DEPTO_DE_CALIDAD = "depto-de-calidad",
	AMPER = "amper",
	BIBLIOTECA = "biblioteca",
	MEDIO_AMBIENTE = "medio-ambiente",
	COMITE_INFECCIONES = "comite-infeccioens",
	NORMAS_PROCEDIMIENTOS = "normas-procedimientos",
	PLAN_SALUD = "plan-de-salud",
	INFECTOLOGIA = "infectologia",
	SISTEMAS_INFORMATICOS = "sistemas-informaticos",
	SEGURIDAD_HIGIENE = "seguridad-higiene",
	RECURSOS_HUMANOS = "recursos-humanos",
	ALERTAS_SANITARIAS = "alertas-sanitarias",
	ACOMPANAR = "acompañar",
	MIS_CURSOS = "mis-cursos",
	REPORTE_INCIDENTES = "reporte-incidentes",
	CLINICAL_KEY = "clinical-key",
	UP_TO_DATE = "uptodate",
	EDRUGS = "edrugs",
	GUIAS_PRACTICAS_CLINICAS = "guias-practicas-clinicas",
	SELF_SERVICE = "self-service",
	MA_SIST_INFO_SOLICITAR_AYUDA = "ma-sist-info-solicitar-ayuda",
	MA_SIST_INFO_ESTADO = "ma-sis-info-estado-actual-solicitud",
	MA_EMP_SOLICITAR_MODIFCACION = "ma-emp-solicitar-modificacion",
	MA_EMP_ESTADO = "map-emp-estado-actual-solicitud",
	MA_RRHH_SOLICITAR_AYUDA = "ma-rrhh-solicitar-ayuda",
	MA_RRHH_ESTADO = "ma-rrhh-estado-actual-solicitud",
	MA_ING_PLANTA_SOLICITAR_AYUDA = "ma-ing-planta-solicitar-ayuda",
	MA_ING_PLANTA_NORMA = "ma-ing-planta-norma",
	MA_ING_PLANTA_INSTRUCTIVO_CENTRAL = "ma-ing-planta-instructivo-sede-central",
	MA_ING_PLANTA_INSTRUCTIVO_SAN_JUSTO = "ma-ing-planta-instructivo-sede-san-justo",
	MA_ING_PLANTA_PLANO_CENTRAL = "ma-ing-planta-plano-sede-central",
	MA_ING_PLANTA_PLANO_SAN_JUSTO = "ma-ing-planta-plano-sede-san-justo",
	MA_NOTI_SOLICITAR_ALTA_NOTICIA = "ma-noti-solicitar-alta",
	MA_NOTI_SOLICITAR_CAMBIOS = "ma-noti-solicitar-cambios",
	MA_NOTI_VER_ESTADO = "ma-noti-estado-actual-solicitud",
	MA_NOTI_VER_ESTADO_CAMBIOS = "ma-noti-estado-actual-cambios",
	MA_NUEVO_EQUIP_SOLICITAR = "ma-nuevo-equip-solicitar",
	MA_NUEVO_EQUIP_ESTADO = "ma-nuevo-equip-estado-actual-solicitud",
	MA_GERENCIA_COMERCIAL_SOLICITAR = "ma-gerencia-comercial-solicitar",
	MA_GERENCIA_COMERCIAL_ESTADO = "ma-gerencia-comercial-estado-actual-solicitud",
	MA_GESTION_IMPLANTES_SOLICITAR = "ma-gestion-implantes-solicitud",
	MA_GESTION_IMPLANTES_ESTADO = "ma-gestion-implantes-estado",
	RECURSOS_HUMANOS_FAQ = "recursos-humanos-preguntas-frecuentes",
	VIOLENCIA_LABORAL_FORM = "violencia-laboral-form",
	PORTAL_PERSONAL_SALUD = "portal-personal-salud",
	PAMT = "pamt",
	BUSQUEDA_PERSONAS = "busqueda-personas",
	BUSQUEDA_TELEFONOS = "busqueda-telefonos",
	DEPTO_DE_INVESTIGACION = "departamento-investigacion",
	RESPONSABILIDAD_SOCIAL = "responsabilidad-social",
	FALTANTES_FORM = "faltantes-form",
	COMITE_ETICA_PROTOCOLOS = "comite-etica-protocolos",
	DONACION_DE_ORGANOS = "donacion-organos-y-tejidos",
	MENU_CENTRAL_SUGERENCIAS = "menu-central-sugerencias",
	MENU_SAN_JUSTO_SUGERENCIAS = "menu-san-justo-sugerencias"
}

export interface ManagedLinkUrl {
	url?: string,
	ida?: string,	// id aplicación
	idp?: string	// id perfil
}

export enum ExternalType { APP, TAB };

export interface ManagedLinkInfo {
	title: string,	// titulo que es usado por el componente breadcrumb
	isExternal?: boolean,
	externalType?: ExternalType,		// Por defecto si es managedLinkKey == STORED_LINK es ExternalType.APP, sino es ExternalType.TAB, ver onClick() de ManagedLinkDirective
	prefixPath?: string			// utilizado en ManagedLinkDirective
}

const MA_MESA_AYUDA_PATH: string = "/principal/mesa-ayuda";
const MA_SIST_INFO_PREFIX_PATH: string = MA_MESA_AYUDA_PATH + "/sistemas-informaticos";
const MA_EMP_PREFIX_PATH: string = MA_MESA_AYUDA_PATH + "/empadronamiento";
const MA_RRHH_PREFIX_PATH: string = MA_MESA_AYUDA_PATH + "/recursos-humanos";
const MA_ING_PLANTA_PREFIX_PATH: string = MA_MESA_AYUDA_PATH + "/ingenieria-planta";
const MA_NOTICIAS_PREFIX_PATH: string = MA_MESA_AYUDA_PATH + "/comunicacion";
const MA_NUEVO_EQUIP_PREFIX_PATH: string = MA_MESA_AYUDA_PATH + "/nuevo-equipamiento";
const MA_GERENCIA_COMERCIAL_PREFIX_PATH: string = MA_MESA_AYUDA_PATH + "/gerencia-comercial";
const MA_GESTION_IMPLANTES_PREFIX_PATH: string = MA_MESA_AYUDA_PATH + "/gestion-implantes";

const REPORTE_PATH: string = "/principal/reportes";
const VIOLENCIA_REPORTE_PREFIX_PATH: string = REPORTE_PATH + "/violencia-laboral/incidencia";
const FALTANTES_REPORTE_PREFIX_PATH: string = REPORTE_PATH + "/faltantes/incidencia";

export const managedLinkInfo: { [k:string]: ManagedLinkInfo } = {};
managedLinkInfo[ ManagedLinkKey.STORED_LINK ] = { title: "" };
managedLinkInfo[ ManagedLinkKey.INFO_MEDICA ] = { title: "Información Médica" };
managedLinkInfo[ ManagedLinkKey.INFO_HOSPITALARIA ] = { title: "Información Hospitalaria" };
managedLinkInfo[ ManagedLinkKey.CLASIFICADOS ] = { title: "Clasificados" };
managedLinkInfo[ ManagedLinkKey.FOTOS ] = { title: "Galería de Fotos" };
managedLinkInfo[ ManagedLinkKey.DEPTO_DE_CALIDAD ] = { title: "Departamento de Calidad" };
managedLinkInfo[ ManagedLinkKey.AMPER ] = { title: "Amper" };
managedLinkInfo[ ManagedLinkKey.BIBLIOTECA ] = { title: "Biblioteca" };
managedLinkInfo[ ManagedLinkKey.MEDIO_AMBIENTE ] = { title: "Medio Ambiente" };
managedLinkInfo[ ManagedLinkKey.COMITE_INFECCIONES ] = { title: "Comité de Infecciones" };
managedLinkInfo[ ManagedLinkKey.NORMAS_PROCEDIMIENTOS ] = { title: "Normas y Procedmientos" };
managedLinkInfo[ ManagedLinkKey.PLAN_SALUD ] = { title: "Plan de Salud" };
managedLinkInfo[ ManagedLinkKey.INFECTOLOGIA ] = { title: "Infectología" };
managedLinkInfo[ ManagedLinkKey.SISTEMAS_INFORMATICOS ] = { title: "Sistemas Informáticos" };
managedLinkInfo[ ManagedLinkKey.SEGURIDAD_HIGIENE ] = { title: "Seguridad e Higiene" };
managedLinkInfo[ ManagedLinkKey.RECURSOS_HUMANOS ] = { title: "Recursos Humanos" };
managedLinkInfo[ ManagedLinkKey.ALERTAS_SANITARIAS ] = { title: "Alertas Sanitarias" };
managedLinkInfo[ ManagedLinkKey.ACOMPANAR ] = { title: "Acompañar" };
managedLinkInfo[ ManagedLinkKey.MIS_CURSOS ] = { title: "Mis Cursos" };
managedLinkInfo[ ManagedLinkKey.REPORTE_INCIDENTES ] = { title: "Reporte de Incidentes y Efectos Adversos" };
managedLinkInfo[ ManagedLinkKey.CLINICAL_KEY ] = { title: "ClinicalKey" };
managedLinkInfo[ ManagedLinkKey.UP_TO_DATE ] = { title: "UpToDate" };
managedLinkInfo[ ManagedLinkKey.EDRUGS ] = { title: "eDrugs" };
managedLinkInfo[ ManagedLinkKey.GUIAS_PRACTICAS_CLINICAS ] = { title: "Guías Prácticas Clínicas" };
managedLinkInfo[ ManagedLinkKey.SELF_SERVICE ] = { title: "Self Service" };
managedLinkInfo[ ManagedLinkKey.MA_SIST_INFO_SOLICITAR_AYUDA ] = { title: "Solicitar Ayuda", prefixPath: MA_SIST_INFO_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_SIST_INFO_ESTADO ] = { title: "Estado Actual de Solicitud", prefixPath: MA_SIST_INFO_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_EMP_SOLICITAR_MODIFCACION ] = { title: "Solicitar Modificación", prefixPath: MA_EMP_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_EMP_ESTADO ] = { title: "Estado Actual de Solicitud", prefixPath: MA_EMP_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_RRHH_SOLICITAR_AYUDA ] = { title: "Solicitar Ayuda", prefixPath: MA_RRHH_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_RRHH_ESTADO ] = { title: "Estado Actual de Solicitud", prefixPath: MA_RRHH_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_ING_PLANTA_SOLICITAR_AYUDA ] = { title: "Solicitar Ayuda", prefixPath: MA_ING_PLANTA_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_ING_PLANTA_NORMA ] = { title: "Norma", prefixPath: MA_ING_PLANTA_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_ING_PLANTA_INSTRUCTIVO_CENTRAL ] = { title: "Instructivo Sede Central", prefixPath: MA_ING_PLANTA_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_ING_PLANTA_INSTRUCTIVO_SAN_JUSTO ] = { title: "Instructivo Sede San Justo", prefixPath: MA_ING_PLANTA_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_ING_PLANTA_PLANO_CENTRAL ] = { title: "Plano Sede Central", prefixPath: MA_ING_PLANTA_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_ING_PLANTA_PLANO_SAN_JUSTO ] = { title: "Plano Sede San Justo", prefixPath: MA_ING_PLANTA_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_NOTI_SOLICITAR_ALTA_NOTICIA ] = { title: "Solicitar Alta de Noticia en Comunità", prefixPath: MA_NOTICIAS_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_NOTI_SOLICITAR_CAMBIOS ] = { title: "Solicitar Cambios en Web o Micrositio", prefixPath: MA_NOTICIAS_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_NOTI_VER_ESTADO ] = { title: "Estado Actual de Solicitud de Noticia en Comunità", prefixPath: MA_NOTICIAS_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_NOTI_VER_ESTADO_CAMBIOS ] = { title: "Estado Actual de Solicitud de Cambios en Web o Micrositio", prefixPath: MA_NOTICIAS_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_NUEVO_EQUIP_SOLICITAR ] = { title: "Solicitar Nuevo Equipamiento", prefixPath: MA_NUEVO_EQUIP_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_NUEVO_EQUIP_ESTADO ] = { title: "Estado Actual de Solicitud", prefixPath: MA_NUEVO_EQUIP_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_GERENCIA_COMERCIAL_SOLICITAR ] = { title: "Solicitar Pedido", prefixPath: MA_GERENCIA_COMERCIAL_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_GERENCIA_COMERCIAL_ESTADO ] = { title: "Estado Actual de Solicitud", prefixPath: MA_GERENCIA_COMERCIAL_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_GESTION_IMPLANTES_SOLICITAR ] = { title: "Solicitar Pedido", prefixPath: MA_GESTION_IMPLANTES_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.MA_GESTION_IMPLANTES_ESTADO ] = { title: "Estado Actual de Solicitud", prefixPath: MA_GESTION_IMPLANTES_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.RECURSOS_HUMANOS_FAQ ] = { title: "Recursos Humanos Preguntas Frecuentes" };
managedLinkInfo[ ManagedLinkKey.VIOLENCIA_LABORAL_FORM ] = { title: "Formulario", prefixPath: VIOLENCIA_REPORTE_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.PORTAL_PERSONAL_SALUD ] = { title: "Portal Personal de Salud" };
managedLinkInfo[ ManagedLinkKey.PAMT ] = { title: "Programa de Asistencia Medica Transcultural" };
managedLinkInfo[ ManagedLinkKey.BUSQUEDA_PERSONAS ] = { title: "Búsqueda de Personas" };
managedLinkInfo[ ManagedLinkKey.BUSQUEDA_TELEFONOS ] = { title: "Búsqueda de Teléfonos" };
managedLinkInfo[ ManagedLinkKey.DEPTO_DE_INVESTIGACION ] = { title: "Departamento de Investigación" };
managedLinkInfo[ ManagedLinkKey.RESPONSABILIDAD_SOCIAL ] = { title: "Responsabilidad Social" };
managedLinkInfo[ ManagedLinkKey.FALTANTES_FORM ] = { title: "Formulario", prefixPath: FALTANTES_REPORTE_PREFIX_PATH };
managedLinkInfo[ ManagedLinkKey.COMITE_ETICA_PROTOCOLOS ] = { title: "Comité de Ética de Protocolos de Investigación" };
managedLinkInfo[ ManagedLinkKey.DONACION_DE_ORGANOS ] = { title: "Donación de órganos y tejidos" };
managedLinkInfo[ ManagedLinkKey.MENU_CENTRAL_SUGERENCIAS ] = { title: "Menú Comedor Central Sugerencias" };
managedLinkInfo[ ManagedLinkKey.MENU_SAN_JUSTO_SUGERENCIAS ] = { title: "Menú Comedor San Justo Sugerencias" };

